import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import css from "highlight.js/lib/languages/css";
import yaml from "highlight.js/lib/languages/yaml";
import php from "highlight.js/lib/languages/php";
import bash from "highlight.js/lib/languages/bash";
import csharp from "highlight.js/lib/languages/csharp";
import xml from "highlight.js/lib/languages/xml";
import java from "highlight.js/lib/languages/java";

export default () => {
  hljs.registerLanguage("javascript", javascript);
  hljs.registerLanguage("css", css);
  hljs.registerLanguage("yaml", yaml);
  hljs.registerLanguage("php", php);
  hljs.registerLanguage("bash", bash);
  hljs.registerLanguage("csharp", csharp);
  hljs.registerLanguage("xml", xml);
  hljs.registerLanguage("java", java);

  document.querySelectorAll(".js-rich-text code").forEach((code) => {
    hljs.highlightBlock(code);
  });

  document.querySelectorAll(".js-rich-text table").forEach((table) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rich-text__table-wrapper");
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
};
